import React, { useState, useEffect, useRef } from "react";
import { db, auth } from "../firebase";
import Form from "./Form";
import SignOut from "./SignOut";
import { v4 as uuid } from "uuid";

function ChatRoom() {
  const scroll = useRef();
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    db.collection("messages")
      .orderBy("createdAt")
      .limit(100)
      .onSnapshot((snapshot) => {
        setMessages(snapshot.docs.map((doc) => doc.data()));
      });
  }, []);
  return (
    <>
      <nav className="navbar navbar-expand-sm bg-dark px-3 py-2">
        <div className="container-fluid">
          <h4 className="text-white">Chat App</h4>
          <SignOut />
        </div>
      </nav>
      <section id="main" className="container-fluid">
        <div className="row">
          <div className="col-md-8 mx-auto">
            <main className="chat-room px-2 py-3 msgs">
              {messages.map(({ id, text, photoURL, uid }) => (
                <div
                  key={uuid()}
                  className={`msg m-2 ${
                    uid === auth.currentUser.uid ? "sent" : "received"
                  }`}
                >
                  <img src={photoURL} alt="" />
                  <p className="p-2 mx-1 my-0">
                    {text.length > 50 ? text.substring(0, 50) + "..." : text}
                  </p>
                </div>
              ))}
              <div ref={scroll}></div>
            </main>
            <Form scroll={scroll} />
          </div>
        </div>
      </section>
    </>
  );
}

export default ChatRoom;
